import React from 'react';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { BlockType } from '../../types/api/ElementType';
import { TitleImageDefaultView } from './views/TitleImageDefaultView';
import { TitleImageEditView } from './views/TitleImageEditView';

type TitleImageProps = Views<DefaultView<TitleImageDefaultView> & OptionalEditView<TitleImageEditView> & DeleteAction>;
function TitleImage({ activeView = 'default', views }: TitleImageProps) {
  const { t } = useSonTranslation('TitleImage');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'TitleImage:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <TitleImageEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(BlockInteractionsViews.DELETE, Icons.ERASER, 'TitleImage:delete', DISPLAY_TYPE.MODAL)),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <TitleImageDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const TitleImageBlock = asFetchableBlock(TitleImage, BlockType.titleimage);
